import { Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AlertPopup = () => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const navigate = useNavigate();

  const handleOk = () => {
    setIsModalVisible(false);
    navigate(-1); // Go back to previous page
  };

  return (
    <Modal
      title={<span style={{ fontWeight: 'bold', color: '#333' }}>Information</span>}
      open={isModalVisible}
      onOk={handleOk}
      okText="OK"
      closable={false}
      centered
      width={500}
      footer={null}
    >
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <InfoCircleOutlined style={{ fontSize: '60px', color: '#4B83FF' }} />
        <p style={{ fontSize: '18px', fontWeight: '500', marginTop: '15px', color: '#333' }}>
          As per <b>HOF Confirmation</b>,
        </p>
        <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#555' }}>
          Service Claim Module has been Closed
        </p>
        <p style={{ color: '#555' }}>Kindly Contact HOF Team</p>

        <button 
          style={{
            backgroundColor: '#4B83FF',
            color: 'white',
            border: 'none',
            padding: '8px 30px',
            borderRadius: '8px',
            fontSize: '14px',
            marginTop: '20px',
            cursor: 'pointer'
          }}
          onClick={handleOk}
        >
          OK
        </button>
      </div>
    </Modal>
  );
};

export default AlertPopup;
